﻿/* exported MobileRightNavigationPanel */

function MobileRightNavigationPanel(config) {
    'use strict';
    MobilePanel.call(this, config);
    this.Position = PanelPosition.RIGHT_NAV;
}

$.extend(MobileRightNavigationPanel.prototype, MobilePanel.prototype,
{
    init: function ()
    {
        MobilePanel.prototype.init.call(this);
        
        // Right menu navigation panel(hamburger menu blocks) is always active for now, most of its data is static
        this.activate();
    }
});

window.MobileRightNavigationPanel = MobileRightNavigationPanel;